export enum AuthErrorCodes {
  AlreadySignedUp = 'AlreadySignedUp',
  NotYetUnlinkTermination = 'NotYetUnlinkTermination',
  Under15YearsOld = 'Under15YearsOld',
  CannotGetCertificationInfo = 'CannotGetCertificationInfo',
  AlreadyUsedCertification = 'AlreadyUsedCertification',
  SignUpFailed = 'SignUpFailed',
  Withdrawn = 'Withdrawn',
  Dormant = 'Dormant',
  NeedSignUp = 'NeedSignUp',
  EmailVerificationTokenIncorrect = 'EmailVerificationTokenIncorrect',
  EmailVerificationTokenExpired = 'EmailVerificationTokenExpired',
}
